import React, { useEffect } from "react";
import { locale } from "devextreme/localization";
import { useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  ColumnChooser,
  SearchPanel,
  Lookup,
  FormItem,
  Summary,
  TotalItem,
  Selection,
  Export,
} from "devextreme-react/data-grid";
import {
  selectEmployees,
  selectReasonCodes,
} from "../../redux/cash-in-out/cash-in-out-selectors";
import Spinner from "../common/Spinner";
import { getNavigatorLanguage } from "../../utils/index";

const CashInOutReportTable = ({ reportStore, isLoading }) => {
  const { reasonCodes } = useSelector(
    createStructuredSelector({
      employees: selectEmployees,
      reasonCodes: selectReasonCodes,
    })
  );

  useEffect(() => {
    locale(getNavigatorLanguage());
  }, []);

  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });
  };

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      {reportStore && !isLoading && (
        <DataGrid
          id="gridContainer"
          dataSource={reportStore}
          showBorders={true}
          hoverStateEnabled={true}
          cellHintEnabled={true}
          remoteOperations={false}
          showRowLines={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          showColumnLines={true}
          rowAlternationEnabled={true}
          wordWrapEnabled={true}
          onToolbarPreparing={onToolbarPreparing}
        >
          <Selection
            mode="multiple"
            selectAllMode="allPages"
            showCheckBoxesMode="always"
          />

          <Export
            enabled={true}
            excelWrapTextEnabled={true}
            fileName="Cash in/out report"
            allowExportSelectedData={true}
          />
          <HeaderFilter visible={true} />
          <FilterRow visible={true} applyFilter="auto" />
          <ColumnChooser enabled={true} mode="select" />
          <SearchPanel visible={true} width={300} />
          <Paging defaultPageSize={50} />
          <Pager
            showNavigationButtons={true}
            showPageSizeSelector={true}
            allowedPageSizes={[50, 100, 200]}
            showInfo={true}
          />
          <Column
            dataField="warehouseName"
            allowEditing={false}
            caption="Location"
          />
          <Column dataField="pointOfSaleName" caption="Register" />
          <Column dataField="employeeName" allowEditing={false} />
          <Column dataField="reasonID" caption="Reason" allowEditing={false}>
            <Lookup
              wrapItemText={true}
              dataSource={reasonCodes}
              displayExpr="name"
              valueExpr="reasonID"
            />
          </Column>
          <Column
            dataField="dateTime"
            caption="Date and time"
            dataType="datetime"
            allowEditing={false}
          />
          <Column dataField="sum" allowEditing={false} />
          <Column
            dataField="currencyCode"
            caption="Currency"
            allowEditing={false}
          />
          <Column dataField="comment" cssClass="wrappedColumnClass">
            <FormItem
              colSpan={2}
              editorType="dxTextArea"
              editorOptions={{ autoResizeEnabled: true }}
            />
          </Column>
          <Summary texts={{ sum: "{0}" }}>
            <TotalItem column="sum" summaryType="sum" />
          </Summary>
        </DataGrid>
      )}
      {isLoading && <Spinner />}
    </div>
  );
};

export default CashInOutReportTable;
